import { Box, MenuItem, Select } from '@mui/material';
import {
    ReactNode,
    createContext,
    useContext,
    useEffect,
    useState,
} from 'react';
import en from './langs/en';
import pl from './langs/pl';
import ua from './langs/ua';

const LanguageContext = createContext({
    language: 'pl',
    setLanguage: (language: string) => {},
});
const LanguagepackContext = createContext(pl);

const languageMap = {
    pl: pl,
    en: en,
    ua: ua,
};

export const LanguagepackProvider = ({ children }: { children: ReactNode }) => {
    const [selectedLanguage, setSelectedLanguage] = useState(
        localStorage.getItem('lng') || 'pl'
    );
    const [languagepack, setLanguagepack] = useState(
        languageMap[selectedLanguage as keyof typeof languageMap]
    );

    useEffect(() => {
        setLanguagepack(
            languageMap[selectedLanguage as keyof typeof languageMap]
        );
    }, [selectedLanguage]);

    return (
        <LanguageContext.Provider
            value={{
                language: selectedLanguage,
                setLanguage: (language: string) => {
                    localStorage.setItem('lng', language);
                    setSelectedLanguage(language);
                },
            }}
        >
            <LanguagepackContext.Provider value={languagepack}>
                {children}
            </LanguagepackContext.Provider>
        </LanguageContext.Provider>
    );
};

const useLanguagepack = () => {
    const languagepack = useContext(LanguagepackContext);
    return languagepack;
};
export default useLanguagepack;

export const useLanguage = () => {
    const language = useContext(LanguageContext);
    return language;
};

export const LanguageSelector = () => {
    const { language, setLanguage } = useLanguage();

    return (
        <Box
            sx={{
                display: 'block',
                position: 'absolute',
                top: 0,
                right: 0,
            }}
        >
            <Select
                size="small"
                variant="standard"
                value={language}
                onChange={(e) => {
                    setLanguage(e.target.value);
                }}
            >
                {Object.keys(languageMap).map((language) => (
                    <MenuItem key={language} value={language}>
                        {language.toUpperCase()}
                    </MenuItem>
                ))}
            </Select>
        </Box>
    );
};
